export function resolveEcTerminalAmount(remainingAmount: number, _keypadAmount: number): number {
  return remainingAmount;
}
